/**
 * @fileoverview DELETE handler for the "/app_settings/:app_group_id/message_prioritization/category/:category_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appSettingsAppGroupIdMessagePrioritizationCategoryCategoryIdCacheKeys } from "./constants";
import type {
  DeleteMessagePrioritizationCategoryProps,
  EmptyResult as DeleteMessagePrioritizationCategoryResult,
} from "./types";

export const deleteMessagePrioritizationCategory = reactQueryMutationAdapter(
  appSettingsAppGroupIdMessagePrioritizationCategoryCategoryIdCacheKeys,
  (props: DeleteMessagePrioritizationCategoryProps): Promise<DeleteMessagePrioritizationCategoryResult> => {
    return fetch(
      `/app_settings/${props.appGroupId}/message_prioritization/category/${props.categoryId}`,
      "DELETE",
      props,
      undefined,
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
